import copy from 'copy-to-clipboard'
import { toast } from 'react-toastify'

const copyToClipboard = (string: string) => {
  copy(string)
  toast('Copied to Clipboard')
}

export default copyToClipboard
